import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { httpClient } from "../../utils/apiCall";
import { API_ENDPOINTS } from '../../config/api';
// Generated API'den import edilecek
// import { AuthApi, type RequestOTPRequest, type VerifyOTPRequest, type User } from '../../generated';

// Bu dosya generated API ile değiştirilecek
// Şimdilik mevcut interface'leri kullanıyoruz

// Auth interfaces
export interface RequestOTPRequest {
  email: string;
}

export interface RequestOTPResponse {
  success: boolean;
  message: string;
  data: string;
  errors: string[];
  traceId: string;
}

export interface VerifyOTPRequest {
  email: string;
  code: string;
}

export interface User {
  id: number;
  email: string;
  fullName: string;
  role: string;
}

export interface VerifyOTPResponse {
  success: boolean;
  message: string;
  data: {
    token: string;
    expiresAt: string;
    user: User;
  };
  errors: string[];
  traceId: string;
}

interface AuthState {
  loading: boolean;
  user: User | null;
  token: string | null;
  expiresAt: string | null;
  error: string | null;
}

const initialState: AuthState = {
  loading: false,
  user: null,
  token: null,
  expiresAt: null,
  error: null,
};

// Generated API kullanımı için örnek async thunk'lar
// Bu thunk'lar generated API ile değiştirilecek

export const requestOTP = createAsyncThunk(
  "auth/requestOTP",
  async (requestData: RequestOTPRequest, thunkAPI) => {
    try {
      const response = await httpClient.post<RequestOTPResponse['data']>(API_ENDPOINTS.AUTH.REQUEST_OTP, requestData);
      
      // Response validation
      if (!response.success) {
        throw new Error(response.message || 'API request failed');
      }
      
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const verifyOTP = createAsyncThunk(
  "auth/verifyOTP",
  async (requestData: VerifyOTPRequest, thunkAPI) => {
    try {
      const response = await httpClient.post<VerifyOTPResponse['data']>(API_ENDPOINTS.AUTH.VERIFY_OTP, requestData);
      
      // Response validation
      if (!response.success) {
        throw new Error(response.message || 'API request failed');
      }
      
      if (!response.data || !response.data.user || !response.data.token) {
        throw new Error('Invalid response format: missing user or token data');
      }
      
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Generated API kullanımı için örnek:
/*
export const requestOTP = createAsyncThunk(
  "auth/requestOTP",
  async (requestData: RequestOTPRequest, thunkAPI) => {
    try {
      // Generated API kullanımı
      const response = await AuthApi.requestOTP(requestData);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const verifyOTP = createAsyncThunk(
  "auth/verifyOTP",
  async (requestData: VerifyOTPRequest, thunkAPI) => {
    try {
      // Generated API kullanımı
      const response = await AuthApi.verifyOTP(requestData);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
*/

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.expiresAt = null;
      state.loading = false;
      state.error = null;
      
      // localStorage'ı temizle
      localStorage.removeItem('authToken');
      localStorage.removeItem('currentUser');
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers(builder) {
    // Request OTP
    builder.addCase(requestOTP.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(requestOTP.fulfilled, (state) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(requestOTP.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload instanceof Error 
        ? action.payload.message 
        : 'OTP isteği başarısız';
    });

    // Verify OTP
    builder.addCase(verifyOTP.pending, (state) => {
      state.loading = true;
      state.user = null;
      state.token = null;
      state.expiresAt = null;
      state.error = null;
    });
    builder.addCase(verifyOTP.fulfilled, (state, action) => {
      state.loading = false;
      state.user = action.payload.data.user;
      state.token = action.payload.data.token;
      state.expiresAt = action.payload.data.expiresAt;
      state.error = null;
      
      // Token'ı localStorage'a kaydet
      localStorage.setItem('authToken', action.payload.data.token);
      localStorage.setItem('currentUser', JSON.stringify(action.payload.data.user));
    });
    builder.addCase(verifyOTP.rejected, (state, action) => {
      state.loading = false;
      state.user = null;
      state.token = null;
      state.expiresAt = null;
      state.error = action.payload instanceof Error 
        ? action.payload.message 
        : 'OTP doğrulama başarısız';
    });
  },
});

export const { logout, clearError } = authSlice.actions;
export default authSlice.reducer;
